import AddCaseContactsListItem from "./Item";

const AddCaseBarchiveList = (props) => {
  if (props.location) {
    return (
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mt-4">
        {props.list.map((item) => (
          <AddCaseContactsListItem
            key={item?.id}
            baygani_code={item.baygani_code}
            id={item.id}
            branch_name={item.branch_name}
            location={props.location}
            item={item}
            setEditItemBarchive={props.setEditItemBarchive}
            edit={props.edit}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mt-4">
      {props.list.map((item) => (
        <AddCaseContactsListItem
          key={item?.id}
          baygani_code={item.baygani_code}
          id={item.id}
          branch_name={item.branch_name}
          location={props.location}
          item={item}
          setEditItemBarchive={props.setEditItemBarchive}
          edit={props.edit}
        />
      ))}
    </div>
  );
};

export default AddCaseBarchiveList;
